/**
 * Tela de seleção FODA — garage NFS + energia Mario Kart.
 * Preview 3D ao vivo do carro + piloto, listas de catálogo, nome, cor, mapa, sala.
 */
import * as THREE from 'three'
import carCatalog, { DEFAULT_CAR } from '../Cars/CarCatalog.js'
import characterCatalog, { DEFAULT_CHARACTER } from '../Content/CharacterCatalog.js'
import mapCatalog, { DEFAULT_MAP } from '../Content/MapCatalog.js'
import { disposeVisual } from '../Cars/CarVisual.js'
import { disposeVisual as disposeChar } from '../Content/CharacterVisual.js'

const COLORS = [
    { hex: 0xFF0000, name: 'Vermelho' },
    { hex: 0x00AA00, name: 'Verde' },
    { hex: 0x0066FF, name: 'Azul' },
    { hex: 0xFFDD00, name: 'Amarelo' },
    { hex: 0xFF66AA, name: 'Rosa' },
    { hex: 0xFF6600, name: 'Laranja' },
    { hex: 0xAA00FF, name: 'Roxo' },
    { hex: 0x00E5FF, name: 'Ciano' },
]

const CAR_ICONS = {
    kart: '🏎️', formula: '🏁', truck: '🛻', convertible: '🐻', classic: '🔧', neonship: '🚀', procedural: '🎨', glb: '📦',
}
const CHAR_ICONS = { procedural: '🧑', glb: '🧍', bear: '🐻', mechanic: '🔧', neonrider: '😎', default: '🧑' }
const MAP_ICONS = { classic: '🏟️', default: '🗺️' }

export default class SelectScreen {
    /**
     * @param {{ mode: 'host'|'join'|'solo', onConfirm: Function, onBack?: Function }} opts
     */
    constructor({ mode = 'host', onConfirm, onBack } = {}) {
        this.mode = mode
        this.onConfirm = onConfirm || (() => {})
        this.onBack = onBack || (() => {})

        this.picked = {
            name: 'Piloto',
            color: COLORS[0].hex,
            car: DEFAULT_CAR,
            character: DEFAULT_CHARACTER,
            map: DEFAULT_MAP,
            roomCode: '',
        }
        try {
            const n = localStorage.getItem('kart_name')
            if (n) this.picked.name = n
            const c = Number(localStorage.getItem('kart_color'))
            if (c && COLORS.some((x) => x.hex === c)) this.picked.color = c
            this.picked.car = localStorage.getItem('kart_car') || DEFAULT_CAR
            this.picked.character = localStorage.getItem('kart_character') || DEFAULT_CHARACTER
            this.picked.map = localStorage.getItem('kart_map') || DEFAULT_MAP
        } catch (_) {}

        this.tab = 'character' // abre direto na escolha do piloto; car | character | map
        this._previewToken = 0
        this._spin = 0
        this._raf = 0
        this.root = null
        this.renderer = null
        this.scene = null
        this.camera = null
        this.previewGroup = null

        this._build()
        this._initPreview()
        this._loadAndRender()
    }

    async _loadAndRender() {
        await Promise.all([
            carCatalog.load(),
            characterCatalog.load(),
            mapCatalog.load(),
        ])
        if (!carCatalog.has(this.picked.car)) this.picked.car = DEFAULT_CAR
        if (!characterCatalog.has(this.picked.character)) this.picked.character = DEFAULT_CHARACTER
        if (!mapCatalog.has(this.picked.map)) this.picked.map = DEFAULT_MAP
        this._renderLists()
        this._updateHero()
        this._refreshPreview()
    }

    _build() {
        const root = document.createElement('div')
        root.id = 'select-screen'
        root.innerHTML = `
            <div class="ss-bg">
                <div class="ss-grid"></div>
                <div class="ss-glow ss-glow-l"></div>
                <div class="ss-glow ss-glow-r"></div>
            </div>

            <header class="ss-header">
                <button type="button" class="ss-back" data-act="back">◀ VOLTAR</button>
                <div class="ss-title-block">
                    <span class="ss-kicker">${this._modeLabel()} <i class="ss-live-dot"></i></span>
                    <h1 class="ss-title">MONTE SUA LENDA</h1>
                    <span class="ss-subtitle">PILOTO · MÁQUINA · ASFALTO</span>
                </div>
                <div class="ss-header-right">
                    <span class="ss-step">01 <i>/</i> 03</span><small>PERSONALIZE SEU SETUP</small>
                </div>
            </header>

            <div class="ss-body">
                <!-- Lista / abas -->
                <aside class="ss-panel ss-panel-list">
                    <div class="ss-list-heading"><span>GARAGEM <b>01</b></span><small>ESCOLHA SUA IDENTIDADE</small></div>
                    <div class="ss-tabs">
                        <button type="button" class="ss-tab active" data-tab="character">PILOTOS</button>
                        <button type="button" class="ss-tab" data-tab="car">CARROS</button>
                        <button type="button" class="ss-tab" data-tab="map">PISTAS</button>
                    </div>
                    <div class="ss-list" id="ss-list"></div>
                </aside>

                <!-- Preview 3D -->
                <section class="ss-panel ss-panel-preview">
                    <div class="ss-preview-frame">
                        <canvas id="ss-canvas"></canvas>
                        <div class="ss-preview-ring"></div>
                        <div class="ss-preview-floor"></div>
                        <div class="ss-preview-badge" id="ss-preview-badge"><span class="ss-preview-live"></span> —</div>
                        <div class="ss-preview-corner ss-corner-tl">CARPANO<br><b>RACING</b></div>
                        <div class="ss-preview-corner ss-corner-br">3D <b>LIVE</b></div>
                    </div>
                    <div class="ss-hero" id="ss-hero">
                        <h2 class="ss-hero-name">—</h2>
                        <p class="ss-hero-meta">—</p>
                    </div>
                </section>

                <!-- Identidade + confirmar -->
                <aside class="ss-panel ss-panel-id">
                    <div class="ss-id-heading"><span class="ss-id-mark">✦</span><div><b>SEU PERFIL</b><small>O GRID VAI LEMBRAR DE VOCÊ</small></div></div>
                    <label class="ss-label">NOME DO PILOTO</label>
                    <input class="ss-input" id="ss-name" maxlength="16" autocomplete="off" spellcheck="false">

                    <label class="ss-label">COR DO KART</label>
                    <div class="ss-colors" id="ss-colors"></div>

                    <div class="ss-summary"><div class="ss-summary-title">SEU LOADOUT <span>● PRONTO PARA CONFIGURAR</span></div>
                        <div class="ss-sum-row"><span>Carro</span><b id="ss-sum-car">—</b></div>
                        <div class="ss-sum-row"><span>Piloto</span><b id="ss-sum-char">—</b></div>
                        <div class="ss-sum-row"><span>Pista</span><b id="ss-sum-map">—</b></div>
                    </div>

                    <div class="ss-room" id="ss-room" style="display:none">
                        <label class="ss-label">CÓDIGO DA SALA</label>
                        <input class="ss-input ss-room-input" id="ss-room-code" maxlength="4" placeholder="ABCD" autocomplete="off">
                    </div>

                    <button type="button" class="ss-confirm" data-act="confirm" id="ss-confirm">
                        ${this._confirmLabel()}
                    </button>
                    ${this.mode !== 'solo' && this.mode !== 'join' ? `
                    <button type="button" class="ss-join-link" data-act="switch-join">Entrar com código de um amigo</button>
                    ` : ''}
                </aside>
            </div>
        `
        document.body.appendChild(root)
        this.root = root

        // name
        const nameEl = root.querySelector('#ss-name')
        nameEl.value = this.picked.name
        nameEl.addEventListener('input', () => {
            this.picked.name = (nameEl.value || '').trim().slice(0, 16)
        })

        // colors
        const colorBox = root.querySelector('#ss-colors')
        for (const c of COLORS) {
            const chip = document.createElement('button')
            chip.type = 'button'
            chip.className = 'ss-color' + (c.hex === this.picked.color ? ' sel' : '')
            chip.style.background = '#' + c.hex.toString(16).padStart(6, '0')
            chip.title = c.name
            chip.addEventListener('click', () => {
                this.picked.color = c.hex
                for (const k of colorBox.children) k.classList.toggle('sel', k === chip)
                this._refreshPreview()
            })
            colorBox.appendChild(chip)
        }

        // room mode
        if (this.mode === 'join') {
            root.querySelector('#ss-room').style.display = 'block'
            root.querySelector('#ss-room-code').addEventListener('input', (e) => {
                this.picked.roomCode = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4)
                e.target.value = this.picked.roomCode
            })
        }

        root.addEventListener('click', (e) => {
            const tab = e.target.closest('[data-tab]')
            if (tab) {
                this.tab = tab.dataset.tab
                root.querySelectorAll('.ss-tab').forEach((t) => t.classList.toggle('active', t.dataset.tab === this.tab))
                this._renderLists()
                this._updateHero()
                return
            }
            const act = e.target.closest('[data-act]')?.dataset.act
            if (act === 'back') {
                this.destroy()
                this.onBack()
            } else if (act === 'confirm') {
                this._confirm()
            } else if (act === 'switch-join') {
                this.mode = 'join'
                root.querySelector('#ss-room').style.display = 'block'
                root.querySelector('#ss-confirm').textContent = this._confirmLabel()
                root.querySelector('.ss-kicker').textContent = this._modeLabel()
                const link = root.querySelector('[data-act="switch-join"]')
                if (link) link.remove()
                try { root.querySelector('#ss-room-code').focus() } catch (_) {}
            }
        })

        // keyboard
        this._onKey = (e) => {
            if (e.code === 'Enter') this._confirm()
            if (e.code === 'Escape') { this.destroy(); this.onBack() }
        }
        window.addEventListener('keydown', this._onKey)
    }

    _modeLabel() {
        if (this.mode === 'solo') return 'CORRIDA SOLO'
        if (this.mode === 'join') return 'ENTRAR NA SALA'
        return 'CRIAR SALA'
    }

    _confirmLabel() {
        if (this.mode === 'solo') return 'COMEÇAR 🏁'
        if (this.mode === 'join') return 'ENTRAR NA SALA 🏁'
        return 'CRIAR SALA 🏁'
    }

    _renderLists() {
        const list = this.root.querySelector('#ss-list')
        list.innerHTML = ''
        let items = []
        if (this.tab === 'car') items = carCatalog.list()
        else if (this.tab === 'character') items = characterCatalog.list()
        else items = mapCatalog.list()

        for (const item of items) {
            const selected =
                (this.tab === 'car' && item.id === this.picked.car) ||
                (this.tab === 'character' && item.id === this.picked.character) ||
                (this.tab === 'map' && item.id === this.picked.map)

            const card = document.createElement('button')
            card.type = 'button'
            card.className = 'ss-card ss-card-' + this.tab + ' ss-item-' + String(item.id).replace(/[^a-z0-9_-]/gi, '') + (selected ? ' sel' : '')
            card.dataset.itemId = item.id
            const icon = this._iconFor(item)
            const typeLabel = item.type === 'glb' ? '3D' : (item.style || item.type || 'STD')
            const characterLore = {
                vital: 'O TANQUE · URSO DE RESPEITO',
                gohan: 'O MECÂNICO · CLÁSSICO IMPECÁVEL',
                artur: 'O COLECIONADOR · PILOTO NEON',
                default: 'PILOTO DE RUA', cap: 'CAPITÃO DO GRID', luigi: 'ESPECIALISTA EM CURVAS'
            }
            const subline = this.tab === 'character' ? (characterLore[item.id] || 'PILOTO DO GRID') : `${item.owner || 'Carpano'} · ${String(typeLabel).toUpperCase()}`
            card.innerHTML = `
                <span class="ss-card-icon">${icon}<i></i></span>
                <span class="ss-card-body">
                    <span class="ss-card-name">${this._esc(item.name)}</span>
                    <span class="ss-card-sub">${this._esc(subline)}</span>
                </span>
                ${selected ? '<span class="ss-card-check">✓</span>' : '<span class="ss-card-chevron">↗</span>'}
            `
            card.addEventListener('click', () => {
                if (this.tab === 'car') this.picked.car = item.id
                else if (this.tab === 'character') {
                    this.picked.character = item.id
                    // combo assinatura do elenco
                    const pair = { vital: 'vital-convertible', gohan: 'gohan-classic', artur: 'artur-ship' }
                    if (pair[item.id]) this.picked.car = pair[item.id]
                } else this.picked.map = item.id
                this._renderLists()
                this._updateHero()
                this._refreshPreview()
            })
            list.appendChild(card)
        }
    }

    _iconFor(item) {
        if (this.tab === 'car') return CAR_ICONS[item.style] || CAR_ICONS[item.type] || '🚗'
        if (this.tab === 'character') return CHAR_ICONS[item.style] || CHAR_ICONS[item.type] || '🧑'
        return MAP_ICONS[item.id] || MAP_ICONS.default
    }

    _updateHero() {
        let item, label
        if (this.tab === 'car') {
            item = carCatalog.get(this.picked.car)
            label = 'CARRO'
        } else if (this.tab === 'character') {
            item = characterCatalog.get(this.picked.character)
            label = 'PILOTO'
        } else {
            item = mapCatalog.get(this.picked.map)
            label = 'PISTA'
        }
        const hero = this.root.querySelector('#ss-hero')
        hero.querySelector('.ss-hero-name').textContent = item?.name || '—'
        const bits = []
        if (item?.owner) bits.push(item.owner)
        if (item?.type) bits.push(item.type)
        if (item?.style) bits.push(item.style)
        if (item?.laps) bits.push(`${item.laps} voltas`)
        if (item?.radius) bits.push(`R${item.radius}`)
        const characterMeta = {
            vital: 'O URSO VITAL · FORÇA BRUTA, CARRO MINÚSCULO',
            gohan: 'GOHAN · MECÂNICA FINA, ESTILO CLÁSSICO',
            artur: 'ARTUR · SKINS RARAS, TECNOLOGIA NEON',
        }
        hero.querySelector('.ss-hero-meta').textContent = this.tab === 'character' && characterMeta[this.picked.character]
            ? characterMeta[this.picked.character]
            : `${label} · ${bits.join(' · ') || '—'}`

        this.root.querySelector('#ss-preview-badge').textContent = item?.name || '—'
        this.root.querySelector('#ss-sum-car').textContent = carCatalog.get(this.picked.car)?.name || '—'
        this.root.querySelector('#ss-sum-char').textContent = characterCatalog.get(this.picked.character)?.name || '—'
        this.root.querySelector('#ss-sum-map').textContent = mapCatalog.get(this.picked.map)?.name || '—'
    }

    _esc(s) {
        return String(s).replace(/[&<>"']/g, (c) => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
        }[c]))
    }

    // ---------- Preview 3D ----------
    _initPreview() {
        const canvas = this.root.querySelector('#ss-canvas')
        const w = canvas.clientWidth || 400
        const h = canvas.clientHeight || 320

        this.renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true })
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2))
        this.renderer.setSize(w, h, false)
        if (THREE.sRGBEncoding != null) this.renderer.outputEncoding = THREE.sRGBEncoding
        else if (this.renderer.outputColorSpace != null) this.renderer.outputColorSpace = THREE.SRGBColorSpace

        this.scene = new THREE.Scene()

        this.camera = new THREE.PerspectiveCamera(35, w / h, 0.1, 50)
        this.camera.position.set(0, 1.6, 6.5)
        this.camera.lookAt(0, 0.6, 0)

        const hemi = new THREE.HemisphereLight(0xaaccff, 0x221133, 0.85)
        this.scene.add(hemi)
        const key = new THREE.DirectionalLight(0xffffff, 0.9)
        key.position.set(3, 6, 4)
        this.scene.add(key)
        const rim = new THREE.DirectionalLight(0x00d4ff, 0.45)
        rim.position.set(-4, 2, -2)
        this.scene.add(rim)
        const fill = new THREE.PointLight(0xff2d55, 0.5, 12)
        fill.position.set(0, 0.5, 2)
        this.scene.add(fill)

        // podium disk
        const disk = new THREE.Mesh(
            new THREE.CylinderGeometry(2.2, 2.4, 0.12, 48),
            new THREE.MeshStandardMaterial({
                color: 0x1a1a28, metalness: 0.6, roughness: 0.35,
                emissive: 0x00d4ff, emissiveIntensity: 0.08,
            })
        )
        disk.position.y = -0.06
        this.scene.add(disk)

        const ring = new THREE.Mesh(
            new THREE.TorusGeometry(2.35, 0.03, 8, 64),
            new THREE.MeshBasicMaterial({ color: 0x00d4ff })
        )
        ring.rotation.x = Math.PI / 2
        ring.position.y = 0.02
        this.scene.add(ring)

        this.previewGroup = new THREE.Group()
        this.scene.add(this.previewGroup)

        const loop = () => {
            this._raf = requestAnimationFrame(loop)
            this._spin += 0.008
            if (this.previewGroup) this.previewGroup.rotation.y = this._spin
            this.renderer?.render(this.scene, this.camera)
        }
        loop()

        this._onResize = () => {
            if (!this.renderer || !canvas) return
            const ww = canvas.clientWidth || 400
            const hh = canvas.clientHeight || 320
            this.camera.aspect = ww / hh
            this.camera.updateProjectionMatrix()
            this.renderer.setSize(ww, hh, false)
        }
        window.addEventListener('resize', this._onResize)
    }

    async _refreshPreview() {
        const token = ++this._previewToken
        // clear previous
        while (this.previewGroup.children.length) {
            const c = this.previewGroup.children[0]
            this.previewGroup.remove(c)
            disposeVisual(c)
            disposeChar(c)
        }

        const color = this.picked.color
        try {
            const [carVis, charVis] = await Promise.all([
                carCatalog.buildVisual(this.picked.car, color),
                characterCatalog.buildVisual(this.picked.character, color),
            ])
            if (token !== this._previewToken) {
                disposeVisual(carVis.group)
                disposeChar(charVis.group)
                return
            }
            this.previewGroup.add(carVis.group)
            this.previewGroup.add(charVis.group)
        } catch (err) {
            console.warn('[select] preview', err)
        }
    }

    _confirm() {
        const name = (this.root.querySelector('#ss-name').value || this.picked.name || 'Piloto').trim().slice(0, 16) || 'Piloto'
        this.picked.name = name
        if (this.mode === 'join') {
            const code = (this.root.querySelector('#ss-room-code')?.value || '').toUpperCase().trim()
            if (!code || code.length < 3) {
                const inp = this.root.querySelector('#ss-room-code')
                if (inp) {
                    inp.focus()
                    inp.style.borderColor = '#ff2d55'
                    setTimeout(() => { inp.style.borderColor = '' }, 800)
                }
                return
            }
            this.picked.roomCode = code
        }
        try {
            localStorage.setItem('kart_name', this.picked.name)
            localStorage.setItem('kart_color', String(this.picked.color))
            localStorage.setItem('kart_car', this.picked.car)
            localStorage.setItem('kart_character', this.picked.character)
            localStorage.setItem('kart_map', this.picked.map)
        } catch (_) {}

        const payload = { ...this.picked, mode: this.mode }
        this.destroy()
        this.onConfirm(payload)
    }

    destroy() {
        window.removeEventListener('keydown', this._onKey)
        window.removeEventListener('resize', this._onResize)
        cancelAnimationFrame(this._raf)
        if (this.previewGroup) {
            while (this.previewGroup.children.length) {
                const c = this.previewGroup.children[0]
                this.previewGroup.remove(c)
                disposeVisual(c)
                disposeChar(c)
            }
        }
        this.renderer?.dispose()
        this.renderer = null
        this.root?.remove()
        this.root = null
    }
}
